// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as Core__Option from "@rescript/core/src/Core__Option.bs.js";
import * as Utils$OrcaPaymentPage from "../Utilities/Utils.bs.js";
import * as Loader$OrcaPaymentPage from "./Loader.bs.js";

function PaymentLoader(props) {
  var match = React.useState(function () {
        return "auto";
      });
  var setBranding = match[1];
  var branding = match[0];
  React.useEffect((function () {
          Utils$OrcaPaymentPage.messageParentWindow(undefined, [[
                  "iframeMountedCallback",
                  true
                ]]);
          var handle = function (ev) {
            var json = Utils$OrcaPaymentPage.safeParse(ev.data);
            var dict = Utils$OrcaPaymentPage.getDictFromJson(json);
            if (Utils$OrcaPaymentPage.getBool(dict, "fullScreenIframeMounted", false) && Core__Option.isSome(Utils$OrcaPaymentPage.getOptionString(Utils$OrcaPaymentPage.getDictFromDict(dict, "options"), "branding"))) {
              return setBranding(function (param) {
                          return Utils$OrcaPaymentPage.getString(Utils$OrcaPaymentPage.getDictFromDict(dict, "options"), "branding", "auto");
                        });
            }
            
          };
          window.addEventListener("message", handle);
          return (function () {
                    window.removeEventListener("message", handle);
                  });
        }), []);
  var styles = branding === "auto" ? "backdrop-blur-md bg-black/80" : "backdrop-contrast-125 backdrop-blur-2xl opacity-70 bg-black/80";
  return React.createElement("div", {
              className: "h-screen w-screen flex m-auto items-center " + styles
            }, React.createElement("div", {
                  className: "flex flex-col justify-center m-auto visible"
                }, React.createElement(Loader$OrcaPaymentPage.make, {
                      branding: branding
                    })));
}

var make = PaymentLoader;

export {
  make ,
}
/* react Not a pure module */
